<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80" label="序号"> </el-table-column>

      <el-table-column prop="Name" label="场馆名称" width=""> </el-table-column>
      <el-table-column
        prop="Desc"
        label="场馆简介"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="BusinessTime" label="营业时间" width="200">
      </el-table-column>
      <el-table-column prop="TelPhone" label="电话号码" width="180">
      </el-table-column>
      <el-table-column
        prop="Adress"
        label="场馆地址"
        show-overflow-tooltip
        width="120"
      >
      </el-table-column>
      <el-table-column prop="Score" label="评分"> </el-table-column>
      <el-table-column prop="Tag" label="标签"></el-table-column>
      <!-- <el-table-column
        prop="PrivateBookingAgreement"
        label="包场协议"
        show-overflow-tooltip
        width="160"
      ></el-table-column>
      <el-table-column
        prop="Instructions"
        label="预订须知"
        show-overflow-tooltip
        width="160"
      ></el-table-column> -->
      <!-- <el-table-column prop="PinLunCount" label="评论数"></el-table-column> -->
      <el-table-column prop="Distance" label="距离"></el-table-column>

      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="text" @click="handleCourt(scope.row)"
            >查看订场</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="delBtn" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.pageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!--编辑/新增界面-->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <el-form
        :model="formData"
        label-width="120px"
        :rules="formRules"
        ref="dataForm"
      >
        <div class="form-group">
          <div class="form-group-title">基本信息</div>
          <el-row :gutter="20">
            <!-- 左列 -->
            <el-col :span="12">
              <el-form-item label="场馆名称" prop="Name">
                <el-input v-model="formData.Name"></el-input>
              </el-form-item>
              <el-form-item label="场馆简介" prop="Desc">
                <el-input v-model="formData.Desc"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="TelPhone">
                <el-input v-model="formData.TelPhone"></el-input>
              </el-form-item>
              <el-form-item label="场馆地址" prop="Adress">
                <el-input v-model="formData.Adress"></el-input>
              </el-form-item>
              <el-form-item label="详细地址" prop="AdressDetail">
                <el-input v-model="formData.AdressDetail"></el-input>
              </el-form-item>
            </el-col>

            <!-- 右列 -->
            <el-col :span="12">
              <el-form-item label="距离" prop="Distance">
                <el-input v-model="formData.Distance"></el-input>
              </el-form-item>
              <el-form-item label="经度" prop="Longitude">
                <el-input v-model="formData.Longitude"></el-input>
              </el-form-item>
              <el-form-item label="纬度" prop="Latitude">
                <el-input v-model="formData.Latitude"></el-input>
              </el-form-item>
              <el-form-item label="标签" prop="Tag">
                <el-select v-model="formData.Tag" multiple style="width: 100%">
                  <el-option
                    v-for="item in tagList"
                    :key="item.Id"
                    :value="item.ItemText"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评分" prop="Score">
                <el-input v-model="formData.Score"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 营业信息分组 -->
        <div class="form-group">
          <div class="form-group-title">营业信息</div>
          <el-form-item label="营业时间" prop="BusinessTime">
            <el-time-picker
              is-range
              v-model="formData.BusinessTime"
              range-separator="至"
              start-placeholder="开业时间"
              end-placeholder="关闭时间"
              placeholder="选择营业时间"
              value-format="HH:mm:ss"
              style="width: 100%"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item label="包场协议" prop="PrivateBookingAgreement">
            <el-input
              v-model="formData.PrivateBookingAgreement"
              type="textarea"
              :rows="4"
            ></el-input>
          </el-form-item>
          <el-form-item label="预订须知" prop="Instructions">
            <el-input
              v-model="formData.Instructions"
              type="textarea"
              :rows="4"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 图片资源分组 -->
        <div class="form-group">
          <div class="form-group-title">图片资源</div>
          <el-form-item label="场馆封面" prop="CoverPict">
            <div class="upload-tip">建议尺寸：800x800px</div>
            <Upload
              v-if="dialogVisible"
              @upload="(url) => handleUpload('CoverPict', url)"
              @delete="() => handleDelete('CoverPict')"
              :fileUrl="formData.CoverPict"
            ></Upload>
          </el-form-item>
          <el-form-item label="场馆平面图" prop="VenuePlan">
            <div class="upload-tip">建议尺寸：1200x600px</div>
            <Upload
              v-if="dialogVisible"
              @upload="(url) => handleUpload('VenuePlan', url)"
              @delete="() => handleDelete('VenuePlan')"
              :fileUrl="formData.VenuePlan"
            ></Upload>
          </el-form-item>
          <el-form-item label="轮播图列表">
            <div class="upload-tip">建议数量：3-5张</div>
            <UploadArr
              v-if="dialogVisible"
              @upload="(urls) => handleUpload('CarouselImage', urls)"
              @delete="(urls) => handleUpload('CarouselImage', urls)"
              :fileUrlArr="formData.CarouselImage"
            ></UploadArr>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="submitForm"
          :loading="submitLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getStadiumList,
  addStadium,
  deleteStadium,
  updateStadium,
  getStadiumDetail,
} from "@/api/stadium/stadium";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { GetSysDictByCode } from "@/api/SysDictionary/SysDictionary";
import Upload from "@/components/Upload.vue";
import UploadArr from "@/components/uploadImgArr.vue";
export default {
  components: { Toolbar, Upload, UploadArr },
  data() {
    return {
      fullscreenLoading: false,
      buttonList: [],
      currentRow: null,
      filters: {},
      list: [],

      total: 0,
      listLoading: false,

      dialogVisible: false, // Combined dialog visibility
      dialogStatus: "add", // 'add' or 'edit'
      submitLoading: false,

      formData: {},
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      tagList: [],
      formRules: {
        Name: [{ required: true, message: "请输入场馆名称", trigger: "blur" }],
        Desc: [{ required: true, message: "请输入场馆简介", trigger: "blur" }],
        BusinessTime: [
          { required: true, message: "请选择营业时间", trigger: "change" },
        ],
        TelPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        Adress: [
          { required: true, message: "请输入场馆地址", trigger: "blur" },
        ],
        Score: [{ required: true, message: "请输入评分", trigger: "blur" }],
        Tag: [{ required: true, message: "请选择标签", trigger: "change" }],
        Longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        Latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        CoverPict: [
          { required: true, message: "请上传封面图片", trigger: "change" },
        ],
        VenuePlan: [
          { required: true, message: "请上传平面图", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    tagChange() {
      console.log(this.formData.Tag);
    },
    getDict() {
      GetSysDictByCode({
        code: "Veneu_CG",
      }).then((res) => {
        this.tagList = res.data.response;
      });
    },
    handleCourt(row) {
      this.$router.push({
        path: "/stadium/court",
        query: { Id: row.Id },
      });
    },
    handleUpload(type, url) {
      this.formData[type] = url;
    },
    handleDelete(type) {
      this.formData[type] = this.dialogStatus === "edit" ? null : "";
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        key: this.filters.name,
      };
      this.listLoading = true;

      getStadiumList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteStadium({
            id: row.Id,
          }).then((res) => {
            if (res.data.success) {
              this.initPage();
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          // Handle cancel
        });
    },
    //显示编辑界面
    handleEdit(row) {
      this.dialogStatus = "edit";
      this.resetForm();

      getStadiumDetail({ Id: row.Id })
        .then((res) => {
          let data = res.data.response;
          // 处理标签
          data.Tag = data.Tag ? data.Tag.split(",").filter(Boolean) : [];
          // 处理营业时间
          data.BusinessTime = data.BusinessTime
            ? data.BusinessTime.split("-")
            : ["", ""];
          // 直接使用后端返回的完整URL
          this.formData = Object.assign({}, this.formData, data);
          this.dialogVisible = true;
        })
        .catch((error) => {
          this.$message.error("获取详情失败");
          console.error(error);
        });
    },
    //显示新增界面
    handleAdd() {
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.resetForm();
    },
    //编辑
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return;

        this.submitLoading = true;
        const data = Object.assign({}, this.formData);

        // 处理营业时间
        if (
          Array.isArray(data.BusinessTime) &&
          data.BusinessTime.length === 2
        ) {
          data.BusinessTime = data.BusinessTime.join("-");
        }

        // 处理标签
        if (Array.isArray(data.Tag)) {
          data.Tag = data.Tag.join(",");
        }

        // 移除UI相关字段

        const request =
          this.dialogStatus === "add" ? addStadium : updateStadium;

        request(data)
          .then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                message: res.data.msg || "操作失败",
                type: "error",
              });
            }
          })
          .catch((error) => {
            console.error(error);
            this.$message({
              message: "操作失败",
              type: "error",
            });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    // Add reset form method
    resetForm() {
      this.formData = {};

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.getDict();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // this.setHeader();
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.delBtn {
  color: #db3636;
}

.el-dialog {
  margin-top: 5vh !important;
  width: 900px !important;
}

.el-dialog__body {
  max-height: 80vh;
  overflow-y: auto;
  padding: 20px;
}

.form-group {
  height: 100%;
  margin-bottom: 20px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.form-group-title {
  font-size: 16px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #ebeef5;
}

.el-row {
  margin-bottom: 20px !important;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-form-item:last-child {
  margin-bottom: 0;
}

.el-textarea__inner {
  font-family: inherit;
}

.el-upload-list {
  margin-top: 10px;
}

.el-button--text {
  padding: 4px 8px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}

.el-button--text:hover {
  border-color: #409eff;
}
</style>
